// SPDX-License-Identifier: Elastic-2.0
/**
 * JWT / device-id storage adapter (T-004 / T-007 / F-348).
 *
 * Centralises the localStorage keys used to persist auth identity, per
 * functional spec § 8.1 / § 8.2 and F-348 (ADR-002 Amendment §A.1):
 *   - `mirlai_jwt`        — cloud-paired JWT (Path A from A5)
 *   - `mirlai_device_id`  — anonymous account-less identity (Free tier)
 *
 * The Zustand `useAuth` store is the in-memory source of truth, but it
 * writes through to these exact keys. This helper survives because
 * non-React consumers (e.g. `rootIndexLoader`, which runs before the
 * store is available in a component context) still need a synchronous
 * read. React surfaces should prefer the store selectors
 * (`useAuth(s => s.jwt)`, `useAuth(s => s.deviceId)`) because they get
 * re-render-on-change for free.
 */

/** Synchronous cloud-JWT read. `null` when there is no cloud session
 * (account-less installs have a device_id, not a JWT). */
export function getStoredJwt(): string | null {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return null;
  }
  return window.localStorage.getItem("mirlai_jwt");
}

/** Synchronous account-less `device_id` read. `null` when the install
 * has no device identity yet (truly unauthenticated). */
export function getStoredDeviceId(): string | null {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return null;
  }
  return window.localStorage.getItem("mirlai_device_id");
}
